import { render, staticRenderFns } from "./startFarmaciasDescuento.vue?vue&type=template&id=472d48fe&"
import script from "./startFarmaciasDescuento.vue?vue&type=script&lang=js&"
export * from "./startFarmaciasDescuento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports